module.exports = __webpack_public_path__ + "assets/img/26.fw.514199af.png";